import { AUTH } from '../constants/actionTypes';
import * as api from '../api/index.js';
import { toast } from 'react-toastify';
export const signin = (formData, router) => async (dispatch) => {
  try {
    const { data } = await api.signIn(formData);
   
    dispatch({ type: AUTH, data });
    toast.success("Login Successfull");
    router.push('/');
  } catch (error) {
    toast.error("Invalid Registration");
  }
};

export const signup = (formData, router) => async (dispatch) => {
  try {
    const  data  = await api.signUp(formData);
   
 toast.success(" Registration Successfull");
       dispatch({ type: AUTH, data });

       router.push('/');
  
 
  } catch (error) {

    toast.error("Invalid Registration");
  }
};
